import React from "react";
import "whatwg-fetch";
import Prismic from "prismic-javascript";
import PrismicConfig from "./prismic-configuration";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store";

export default class PrismicApp extends React.Component {
  constructor(props) {
    super(props);
    this.state = { prismicCtx: null };
    this.buildContext()
      .then(prismicCtx => {
        this.setState({ prismicCtx });
      })
      .catch(e => {
        console.error(
          `Cannot contact the API, check your prismic configuration:\n${e}`
        );
      });
  }

  buildContext() {
    const accessToken = PrismicConfig.accessToken;
    return Prismic.api(PrismicConfig.apiEndpoint, { accessToken }).then(
      api => ({
        api,
        endpoint: PrismicConfig.apiEndpoint,
        accessToken,
        linkResolver: PrismicConfig.linkResolver
      })
    );
  }

  render() {
    return (
      <Provider store={store}>
        <App prismicCtx={this.state.prismicCtx} />
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/PrismicApp.js